module.exports = __webpack_public_path__ + "img/emoji_68.ba3a51d9.png";